<form [formGroup]="lobbyEntriesDeleteForm">
  <kendo-dialog title="{{'_Shared_ModalPopUp_Lobby_Delete_Title_Text_' | translate }}" (close)="close()" *ngIf="dialogOpened">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <label for="reason">{{'_Shared_ModalPopUp_Lobby_Delete_Confirm_Text_' | translate }}
      <span tabindex="-1" class="required-field">*</span>
    </label>
    <div class="cc-textarea">
      <textarea id="reason" class="form-control" formControlName="reason" rows="4" cols="60" app-filter
      pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?\\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,#$])*$" maxlength="255"></textarea>
    </div>
    <div class="cc-validation">
      <div id="reasonRequiredErrorMessage" *ngIf="lobbyEntriesDeleteForm.get('reason')?.touched && lobbyEntriesDeleteForm.get('reason')?.hasError('required')">
         {{'_Shared_ModalPopUp_Lobby_Delete_Required_Text_' | translate }}
      </div>
    </div>
    <kendo-dialog-actions class="cc-btn-panel">
      <button class="btn btn-secondary" (click)="close()">{{'_General_Button_Close_Text_' | translate }}</button>
      <button class="btn btn-primary" primary="true" [disabled]="!this.lobbyEntriesDeleteForm.dirty || !this.lobbyEntriesDeleteForm.valid" (click)="delete()">
        {{'_Shared_ModalPopUp_Lobby_Delete_Confirm_Button_Text_' | translate }}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</form>
